import { render } from "./ViewAppliedJobs.vue?vue&type=template&id=1b0b3c94&scoped=true"
import script from "./ViewAppliedJobs.vue?vue&type=script&lang=js"
export * from "./ViewAppliedJobs.vue?vue&type=script&lang=js"

import "./ViewAppliedJobs.vue?vue&type=style&index=0&id=1b0b3c94&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src1919945302/src/app.tamildata.org/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b0b3c94"]])

export default __exports__